export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../assets/images/about/about-banner.jpg'),
        title: 'global it services company',
        description: 'With branches in both China and the USA, MaesInfo is well positioned to serve clients globally, around the clock, catering to their needs on an individual basis.',
        component: ''
      }
  ],
  story:{
   title: 'our story',
   description: '<span class="img" style="background:url('+require('../../assets/images/about/about-pic-1.jpg')+')"></span>'+
   '<p>Founded in 2005, MaesInfo has become a leading provider of professional IT Outsourcing, software development, IT solutions and BPO services for clients worldwide. MaesInfo\'s Global Development Centers in China and the USA have developed long-standing partnerships with its clients, including Fortune 500 companies in Manufacturing, Financial Services, Healthcare and Retail/Wholesale sectors. With its extensive track record working across various industries, MaesInfo has the experience of molding its solutions to different types of companies of all different sizes.</p><p> Our team includes business analysts, architects,process consultants, interface designers, software engineers, DBA and QA/QC engineers, experienced in a rangeof different programming languages, frameworks, and industries.</p>'
  },
  otherItem:[
    {
      title: 'our vision',
      imgUrl: require('../../assets/images/about/about-pic-2.jpg'),
      description: 'MaesInfo seeks to be the leading software outsourcer in China for delivering high-quality IT outsourcing and BPO services with superior value to clients, shareholders and associates around the world.',
      component: ''
    },
    {
      title: 'our mission',
      imgUrl: require('../../assets/images/about/about-pic-3.jpg'),
      description: 'Through our professionalism and diligence, we endeavor to provide our clients with the highest quality IT services world wide.'
    },
    {
      title: 'our culture',
      imgUrl: require('../../assets/images/about/about-pic-4.jpg'),
      description: 'staff and training: Native English-speaking staff from the US, Canada and Australia to better facilitate communications between clients and development staff; language training for each member of the staff.'
    },
    {
      title: 'our leadership',
      imgUrl: require('../../assets/images/about/about-pic-3.jpg'),
      description: 'MaesInfo’leadership team brings a wealth of experience from top global enterprises'
    },
    {
      title: 'our advantage',
      imgUrl: require('../../assets/images/about/about-pic-5.jpg'),
      description: 'MaesInfo can offer a disciplined approach to offshore IT Outsourcing (ITO), Business Process Outsourcing (BPO) and software development for businesses of all sizes. Our high-quality and low-cost operating model allows us to pass on cost savings to our clients, while improving productivity and predictability within your business process environment.'
    }
  ]

}
